import { gql } from 'src/generated/gql';

export const SIGN_LAB_RESULT = gql(`
  mutation SignLabResult($id: ID!) {
    staff_signLabResult(id: $id) {
      id
    }
  }
`);
